export const GET_REPAS_HISTORY = "GET_REPAS_HISTORY";
export const GET_REPAS_HISTORY_REQUEST = "GET_REPAS_HISTORY_REQUEST";
export const GET_REPAS_HISTORY_FAILURE = "GET_REPAS_HISTORY_FAILURE";
